/*eslint-disable*/
// chakra imports
import {
  Box, useColorModeValue, Image, useColorMode
} from "@chakra-ui/react";
import React from "react";
import SidebarContent from "./SidebarContent";
import logo from "../../assets/img/whitelogo.png";
import sidebarBackground from "../../assets/img/backarrow.jpg";

// FUNCTIONS
function Sidebar(props) {
 
  const mainPanel = React.useRef();
  let variantChange = "0.2s linear";

  const { routes, sidebarVariant } = props;

  let sidebarBg = `url(${sidebarBackground})`; 
  let sidebarRadius = "16px"; 
  let sidebarMargins = "0px";
  
  if (sidebarVariant === "opaque") {
    sidebarBg = useColorModeValue("white", "gray.700");
    sidebarRadius = "16px";
    sidebarMargins = "16px 0px 16px 16px";
  }

  const LogoComponent = () => {
    const { colorMode } = useColorMode();
    
    return (
      <Box display="flex" alignItems="center" justifyContent="center">
        <Image 
          src={colorMode === 'dark' ? logo : logo} 
          alt="Logo" 
          height="35px" 
        />
      </Box>
    );
  };

  // SIDEBAR
  return (
    <Box ref={mainPanel}>
      <Box display={{ sm: "none", xl: "block" }} position="fixed">
        <Box
          bgImage={sidebarBg} 
          bgSize="cover"
          bgPosition="center" 
          transition={variantChange}
          w="260px"
          maxW="260px"
          ms={{
            sm: "16px",
          }}
          my={{
            sm: "16px",
          }}
          h="calc(100vh - 32px)"
          ps="20px"
          pe="20px"
          m={sidebarMargins}
          borderRadius={sidebarRadius}
          overflowY="auto"
        >
          <SidebarContent
            routes={routes}
            logoText={<LogoComponent />}
            display="none"
            sidebarVariant={sidebarVariant}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default Sidebar;
